import type {ReactNode} from 'react';
import {PostHogProvider as OfficialPostHogProvider} from 'posthog-js/react';
import {initializeAnalytics} from './analytics';

interface Props {
  children: ReactNode;
}

export function PostHogProvider({children}: Props) {
  const client = initializeAnalytics();

  return (
    <OfficialPostHogProvider client={client}>
      {children}
    </OfficialPostHogProvider>
  );
}
